import { render } from "./error-report-display.vue?vue&type=template&id=67b64da0"
import script from "./error-report-display.vue?vue&type=script&lang=js"
export * from "./error-report-display.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__